module.exports = __webpack_public_path__ + "img/Quest-logo-plain_246x50.dc14c698.png";